import type { ComponentType } from 'react';
import type { IFormBuilder } from '../FormBuilder';

type FormBuilderComponent = ComponentType<IFormBuilder<any>>;

let registeredFormBuilder: FormBuilderComponent | undefined;

export function registerNestedFormBuilder(formBuilder: FormBuilderComponent) {
    registeredFormBuilder = formBuilder;
}

export function getNestedFormBuilder(): FormBuilderComponent {
    if (!registeredFormBuilder) {
        throw new Error('FormBuilder не зарегистрирован: модуль @molecules/formbuilder/FormBuilder не загружен');
    }

    return registeredFormBuilder;
}
